// extracted by mini-css-extract-plugin
export var quantityInput = "_hi-0";